<template>

  <ul
    class="navbar-nav mr-3">
    <li class="nav-item dropdown">
      <a
        class="nav-link dropdown-toggle py-1 px-3 btn btn-outline-secondary"
        href="#"
        id="navbarDropdown"
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false">
        {{ isRhevolut ? 'Rhevolut' : 'PipeTalent'  }}
        </a>
      <div
        class="dropdown-menu"
        aria-labelledby="navbarDropdown">
        <router-link
          v-if="!isRhevolut"  
          class="dropdown-item"
          to="/rhevolut">{{ $t('Rhevolut') }}</router-link>
        <router-link
          v-if="isRhevolut"
          class="dropdown-item"
          to="/">{{ $t('PipeTalent') }}</router-link>
      </div>
    </li>
  </ul>

</template>

<script>
export default {
  name: 'Main',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    currentRoute () {
      return this.$route.path
    },
    isRhevolut () {
      return this.currentRoute.startsWith('/rhevolut')
    }
  },
  created () {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nav-item > .nav-link > i {
  font-size: 1.25em;
}
.navbar .cursor-pointer {
  cursor: pointer;
}
.nav-item > .nav-link > .badge {
  float: right; margin: -3px 0 0 -3px
}

@media (max-width : 576px) {
  .navbar-collapse {
    overflow: auto;
    max-height: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainMenuChangeModule.vue